import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ModalSelectWrapper } from '@app/components/modal-select/modal-select.component';
import { SuccessDialogTemplateComponent } from '@app/components/success-dialog-template/success-dialog-template.component';
import { panelClasses } from '@app/shared/components/common-dialog/common-dialog.component';
import { ConfirmDialogComponent, DialogData } from '@app/shared/components/confirm-dialog/confirm-dialog.component';
import { DialogWrapper } from '@app/shared/components/dialog/dialog.component';
import {
  ModalMenuData,
  ModalMenuWrapper,
} from '@app/shared/components/modal-menu/modal-menu.component';
import { TitleChangeComponent } from '@app/shared/components/title-change/title-change.component';
import { filter, map } from 'rxjs';
import { UserSelect } from './modal.model';

const config = {
  maxWidth: '320px',
  panelClass: 'reset-panel',
  autoFocus: false,
};

export const fullscreenConfig = {
  panelClass: 'fullscreen',
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  disableClose: true,
  autoFocus: false,
};

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog) { }

  // new add-on
  recordSubmitPopup(msg: string) {
    const payload = {
      maxWidth: '90%',
      maxHeight: '90%',
      width: '80%',
      hasBackdrop: true,
      backdropClass: 'bg-black',
      panelClass: panelClasses,
      data: {
        message: msg
      }
    }
    return this.dialog.open(SuccessDialogTemplateComponent, payload);
  }

  message(message: string) {
    return this.dialog.open(DialogWrapper, {
      ...config,
      data: { message },
    });
  }

  menu(list: ModalMenuData[]) {
    return this.dialog.open(ModalMenuWrapper, {
      ...config,
      disableClose: true,
      data: { list },
    });
  }

  select(data: UserSelect) {
    return this.dialog.open(ModalSelectWrapper, {
      ...fullscreenConfig,
      data,
    });
  }

  titleChange(
    current: { ttlkbn: string, ttlcd: string },
    pending?: { ttlkbn: string, ttlcd: string }) {
    return this.dialog.open(TitleChangeComponent, {
      maxWidth: '382px',
      width: 'calc(100% - 32px)',
      disableClose: true,
      autoFocus: false,
      data: {
        current,
        pending
      }
    });
  }

  selectUserInTeam() {

  }
  // progressionDialog() {
  //   const half = {
  //     panelClass: 'fullscreen',
  //     disableClose: true,
  //     autoFocus: false,
  //   }
  //   return this.dialog.open(ProgressionComponent, {
  //     ...half
  //   });
  // }

  // menuDropdown(top?: string, left?: string, width?: string, maxHeight?: string, filterMenus?: MenuTypeEnum[], current?: string) {
  //   const config: MatDialogConfig = {
  //     position: {
  //       top: (top || '0') + 'px',
  //       left: (left || '0') + 'px',
  //     },
  //     data: {
  //       filterMenu: filterMenus || [],
  //       current: current
  //     },
  //     width: (width || '0') + 'px',
  //     maxWidth: 'unset',
  //     // height: height || '0' + 'px',
  //     maxHeight: (maxHeight || 1000) + 'px',
  //     // hasBackdrop: false,
  //     closeOnNavigation: true,
  //     disableClose: false,
  //     autoFocus: true
  //   }
  //   return this.dialog.open(MenuDropdownComponent, config)
  // }


  confirm(data: Confirm) {
    return this.dialog.open(ConfirmDialogComponent, {
      maxWidth: '382px',
      width: 'calc(100% - 32px)',
      disableClose: true,
      autoFocus: false,
      data,
    });
  }

  // aigo(data: any) {
  //   return this.dialog.open(AigoModalComponent, {
  //     width: '100%',
  //     disableClose: true,
  //     autoFocus: false,
  //     data,
  //   });
  // }

  confirmLeavePage() {
    // try implement ..
    const content = `編集中のデータは保存されません。\nよろしいですか？`;
    const data: Confirm = {
      cancelText: 'いいえ',
      excuteText: 'はい',
      content,
      style: {
        'white-space': 'pre-line',
        'text-align': 'center'
      }
    };
    const dialogRef = this.confirm(data);
    return dialogRef.afterClosed().pipe(map((result) => !!result));
  }

  confirmOutDate(list: string[]) {
    const names = list.join('"、"');
    const content = `”${names}”の開始日時・終了日時が予定時間外です。<br>このまま記録してよろしいですか？`;
    const data = {
      cancelText: 'いいえ',
      excuteText: 'はい',
      content,
    };
    const dialogRef = this.confirm(data);
    return dialogRef.afterClosed().pipe(filter((result) => !!result));
  }

  // note retry dialog
  private _failDialogTemplate(content: string) {
    return {
      cancelText: 'いいえ',
      excuteText: 'はい',
      content,
      style: {
        margin: '0'
      }
    }

  }
  updateRetry(message: string = 'エラーが発生しました。もう一度お試しください', retryFunc?: Function, cancelFunc?: Function) {
    // call a dialog
    this.confirm(this._failDialogTemplate(message))
      .afterClosed().pipe(map((result) => !!result))
      .subscribe((isRetry: boolean) => {
        if (isRetry) {
          // this.onSubmit();
          if (retryFunc) {
            retryFunc();
          }
        } else {
          if (cancelFunc) {
            cancelFunc();
          }
        }
      });
  }

  removeAll() {
    this.dialog.closeAll();
  }

  // snackbar alternative
  // using modal
  successAlert(message: string) {
    const data: DialogData = {
      cancelText: '',
      excuteText: '閉じる',
      content: `<p>${message}</p>`,
      style: {
        'text-align': 'center'
      }

    };
    return this.confirm(data);
  }

  custom(data: any, option?: MatDialogConfig) {
    return this.dialog.open(data, option);
  }
}

export interface Confirm {
  cancelText: string;
  excuteText: string;
  content: string;
  style?: any;
}
